import { useReducer } from 'react'
import { formReducer } from '../formReducer'
import {
  OrderData,
  NumberType,
  Order,
  OrderStatus,
  PhotoTypes,
  ResourceType,
  TestResultType,
} from '../types'
import moment from 'moment'
const INIT_FORM: Order = {
  orderId: null,
  orderNumber: null,
  deliveryDate: null,
  centerId: null,
  centerName: null,
  supplierId: null,
  supplierName: null,
  shipId: null,
  shipName: null,
  statusDetail: null,
  pontoonId: null,
  pontoonName: null,
  numberOfLiters: null,
  testResult: null,
  meterNumber: null,
  voucherNumber: null,
  photos: null,
  stateForm: null,
  savedAt: null,
}

const MAP_PHOTO_TYPE: Record<PhotoTypes, ResourceType> = {
  voucherPhoto: 'Comprobante',
  finalPhotoMeter: 'Lectura medidor Final',
  finalPhotoRod: 'Prueba de agua Final',
  initialPhotoMeter: 'Lectura medidor Inicial',
  initialPhotoRod: 'Prueba de agua Inicial',
}

export const WATER_TEST_STATE = 'Prueba de agua positiva'
export const useFormRecord = () => {
  const [form, setForm] = useReducer(formReducer, INIT_FORM)

  const handleOrderByType = (
    values: OrderData & { statusTime: string },
    type: 'manual' | 'automatic',
  ) => {
    setForm({
      type: 'initialData',
      payload: values,
    })
    switch (type) {
      case 'manual':
        setStatusDetail('Creado')
        return
      case 'automatic':
        setStatusDetail('Creado', values.statusTime)
        return
    }
  }

  const handleTakePhoto = (values: { type: PhotoTypes; uri: string }) => {
    setForm({
      type: 'setPhoto',
      payload: {
        dateTime: new Date().getTime().toString(),
        resourceType: MAP_PHOTO_TYPE[values.type],
        uri: values.uri,
        type: values.type,
      },
    })
  }

  const handleValueNumber = (values: { value: number; type: NumberType }) => {
    setForm({
      type: 'setNumber',
      payload: values,
    })

    if (values.type === 'meterNumber' && form.testResult === 'Negativo') {
      setStatusDetail('En Recepción')
    }
  }

  const handleResultTest = (value: TestResultType) => {
    setForm({
      type: 'statusChange',
      form: {
        type: 'setTestResult',
        payload: value,
      },
      payload: { status: WATER_TEST_STATE, time: moment().format('YYYY-MM-DDTHH:mm:ss') },
    })
  }

  const handleResetForm = () => {
    setForm({
      type: 'setForm',
      payload: INIT_FORM,
    })
  }
  const handleSetInitialValues = (form: Order) => {
    setForm({
      type: 'setForm',
      payload: form,
    })
  }

  const setStatusDetail = (status: OrderStatus, time = moment().format('YYYY-MM-DDTHH:mm:ss')) => {
    setForm({
      type: 'statusChange',
      payload: { status, time },
    })
  }
  return {
    form,
    handleResultTest,
    handleValueNumber,
    handleTakePhoto,
    handleOrderByType,
    handleResetForm,
    handleSetInitialValues,
    setStatusDetail,
  }
}
